<template>
  <div class="w3-card" style="background-color: #fff">
    <div class="w3-theme-light">
      <user-header v-bind:user="statement.meta.creator" />
    </div>
    <div style="padding-bottom: 5px; margin:10px">{{statement.text}}</div>
    <div>
      <statement-references v-bind:statement="statement" v-bind:isEditable="isEditable" />
    </div>
    <br/>
    <div>
      <statement-tags v-bind:statement="statement" v-bind:isEditable="isEditable" />
    </div>
    <br/>
    <component v-bind:is="'statement-'+buttonType" v-bind:statement="statement" v-bind:convo="convo" />
  </div>
</template>

<script>
  import StatementView from "./StatementView.ts"

  export default StatementView
</script>
